// THE ADMIN ORDER PAGE IS KEYED BY THE SHOPIFY ID, NOT THE ORDER NAME.
//
// The route is `/admin/orders/:shopifyOrderId` and AdminOrderDetailPage uses
// that param verbatim for every call it makes — load, status change, PDF. On
// 2026-09-21 every row in the Pilotage lists and every open card linked to
// `/admin/orders/%23D305` — the NAME, url-encoded — so every click from the
// dashboard landed on "order not found". The only link on the Assistant page
// that worked was OpenLoopsCard's, the one that happened to have the id.
//
// One function, so the next list cannot pick the wrong field again.
// ⚠️ NO ID MEANS NO LINK, never a guess from the name: the callers fall back
// to opening the conversation, which always works.
export function adminOrderHref(row: { shopifyOrderId?: string | null }): string | null {
  const id = String(row.shopifyOrderId ?? '').trim();
  return id ? `/admin/orders/${encodeURIComponent(id)}` : null;
}
